/** Multi-select publication filtering by research area. */

interface FilterChip extends HTMLElement {
  selected: boolean;
}

export function initPublicationFilter(): void {
  const chips = [...document.querySelectorAll<FilterChip>('md-filter-chip')];
  const pubs = [...document.querySelectorAll<HTMLElement>('.pub')];
  if (!chips.length || !pubs.length) return;

  const allChip = chips.find((chip) => chip.dataset['filter'] === 'all');
  const areaChips = chips.filter((chip) => chip.dataset['filter'] !== 'all');

  const apply = (): void => {
    // Show a paper when no areas are selected, or it matches ANY selected area.
    const active = areaChips.filter((chip) => chip.selected).map((chip) => chip.dataset['filter']);
    for (const pub of pubs) {
      const tags = (pub.dataset['tags'] ?? '').split(' ');
      const show = active.length === 0 || active.some((tag) => tag !== undefined && tags.includes(tag));
      pub.classList.toggle('hide', !show);
    }
  };

  // md-filter-chip toggles its own `selected` before re-dispatching this click.
  for (const chip of chips) {
    chip.addEventListener('click', () => {
      if (chip.dataset['filter'] === 'all') {
        if (allChip) allChip.selected = true; // "All" always means show everything
        for (const area of areaChips) area.selected = false;
      } else if (allChip) {
        allChip.selected = !areaChips.some((area) => area.selected);
      }
      apply();
    });
  }
}
